import React from 'react';
import styles from '../policyDetails.module.scss';
import { useRouter } from 'next/navigation';
import { ROUTER_GROUPS } from '@/core/constants/routes';
import { replacePlaceholders } from '@/core/utils/format.utils';
import { IconChevronRight } from '@tabler/icons-react';
import Image from 'next/image';
import { useDashboard } from '@/contexts/dashboard/dashboard.context';
import { PolicyObject } from '@/data/api/policy/types/policyObject.types';
import { filterExpiredAndCancelledPolicies } from '@/core/utils/policy.util';
import { Label } from '@/design-system/text/label/label';
import { BodyS } from '@/design-system/text/bodyS/bodyS';

const ExpiredCancelledComp = ({
  title,
  policies,
}: {
  title: string;
  policies: PolicyObject[];
}) => {
  const { dashboardLabels } = useDashboard();
  const { policyDetailsCms } = dashboardLabels;
  const router = useRouter();

  const length = filterExpiredAndCancelledPolicies(policies).length;

  if (length === 0) return null;
  return (
    <div
      className={styles['cards-con']}
      onClick={() => {
        if (title === 'Cancelled') {
          router.push(`${ROUTER_GROUPS.policy.cancelledPolicySelection}`);
        } else {
          router.push(`${ROUTER_GROUPS.policy.expiredPolicySelection}`);
        }
      }}
    >
      <Label
        text={`${title.toLowerCase() === 'expired' ? 'PAST' : title.toUpperCase()} ${length > 1 ? 'POLICIES' : 'POLICY'}`}
      />
      <div className={styles['exp-con']}>
        <div className={styles['content-con']}>
          <Image
            src={policyDetailsCms.expiredCancelledView.healthCardImg}
            alt="expired"
            width={48}
            height={48}
          />
          <div className={styles['text-con']}>
            <Label
              text={replacePlaceholders(
                policyDetailsCms.expiredCancelled.title,
                {
                  policy: `${length} ${title.toLowerCase() === 'expired' ? 'past' : title.toLowerCase()} ${length > 1 ? 'policies' : 'policy'}`,
                }
              )}
            />
            <BodyS
              text={replacePlaceholders(
                policyDetailsCms.expiredCancelled.subtitle,
                {
                  policy: `${title.toLowerCase() === 'expired' ? 'past' : title.toLowerCase()} policies`,
                }
              )}
            />
          </div>
        </div>
        <IconChevronRight
          size={20}
          color="var(--base-midnight)"
          className={styles['chevron']}
        />
      </div>
    </div>
  );
};

export default ExpiredCancelledComp;
